var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSidebarTabOpenDark(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 42,
    viewBox: "0 0 26 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h21a5 5 0 015 5v32a5 5 0 01-5 5H0V0z",
    fill: "#3C4551"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.923 21.64a.778.778 0 010-1.28l6.606-4.576a.778.778 0 011.221.639v9.154a.778.778 0 01-1.22.64l-6.607-4.578z",
    fill: "#fff"
  })));
}
export default SvgSidebarTabOpenDark;